// src/node_modules/@awesome.me/kit-63db24046b/icons/modules/kit/custom.mjs
var faRailway = {
  prefix: "fak",
  iconName: "railway",
  icon: [
    512,
    512,
    [],
    "e00b",
    "M2.4 219.1c-1.2 8.5-2 17.2-2.4 25.8l388.9 0c-1.4-2.7-3.2-5-5-7.4-66.5-85.9-102.2-78.4-153.4-80.6-17.1-.7-28.6-1-96.5-1-36.3 0-75.8 .1-114.3 .2-5 13.4-9.8 26.5-12.1 37.1l199.3 0 0 26-204.4 0zM392 270.8L.2 270.8c.4 6.9 1.1 13.8 2 20.5l361.7 0c16.1 0 25.1-9.1 28.1-20.5zM22.5 362.2S82.5 509.4 255.7 512c103.6 0 192.5-61.5 233-149.8l-466.2 0zM255.7 0C160 0 76.7 52.6 32.7 130.3 67 130.2 134 130.2 134 130.2l0 0 0 0c79.2 0 82.1 .4 97.6 1l9.6 .4c33.4 1.1 74.3 4.7 106.6 29.1 17.5 13.2 42.8 42.4 57.9 63.3 13.9 19.2 17.9 41.4 8.5 62.6-8.7 19.5-27.5 31.1-50.2 31.1l-355.5 0s2.1 9 5.3 18.9l485.3 0c8.6-25.9 13-53 13-80.3 0-141.4-114.7-256.1-256.3-256.1z"
  ]
};
export {
  faRailway
};
